import styles from './Dot.module.css'

// ─────────────────────────────────────────────
// 型定義
// ─────────────────────────────────────────────
export type DotProps = {
  /** true のとき Active 状態（黄色） / false のとき Inactive 状態（グレー）*/
  active?: boolean
  className?: string
}

// ─────────────────────────────────────────────
// コンポーネント
// ─────────────────────────────────────────────
/**
 * ページネーション・進捗表示に使う 8px のドットインジケーター。
 *
 * @example
 * <Dot active />
 * <Dot active={false} />
 */
export const Dot = ({ active = true, className }: DotProps) => {
  return (
    <span className={[styles.dot, active ? styles.active : '', className ?? ''].join(' ').trim()} aria-hidden="true" />
  )
}
